module.exports = __webpack_public_path__ + "img/pasos1-2.738c93bd.png";